import React from 'react'

const OurApps = () => {
    return (
        <div className='bg-[#00101D]/95'>
            <div className='max-w-5xl mx-auto flex justify-center gap-4 p-10 items-center'>
                <img src="/assets/talent-icon.png" alt="Talent Lockr" className='w-10 md:w-[85px]' />
                <img src="/assets/cross-icon.png" alt="Cross" className='w-10 md:w-[85px]' />
                <img src="/assets/collide-icon.png" alt="Collide" className='w-10 md:w-[85px]' />
                <img src="/assets/ibiza-only-icon.png" alt="Ibiza Only" className='w-10 md:w-[85px]' />
                <img src="/assets/holeout-icon.png" alt="Holeout" className='w-10 lg:w-[85px]' />
                <img src="/assets/iaw-icon.png" alt="IAW" className='w-10 md:w-[85px]' />
            </div>
        </div>
    )
}

export default OurApps